<template>
  <div class="flex flex-wrap" v-if="filters && filters.length > 0">
    <div
      v-for="status in filters"
      :key="status"
      class="relative project-status whitespace-no-wrap px-3 status m-px"
      :class="status"
    >
      {{ statusLabel[status] }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["i18n"],
  computed: {
    ...mapState({
      filters: (state) =>
        state.dashboard.projects.filters &&
        state.dashboard.projects.filters.statuses,
      statusLabel: (state) => state.dashboard.projects.statuses,
    }),
  },
};
</script>
